import { FormikProps } from "formik";
import { HStack, VStack, Box, Input } from "@chakra-ui/react";
import { WellLevelViewFormValues } from "../../../types/wellLevelsForm";
import { SelectWellLevelsSites } from "../SelectWellLevelsSites/SelectWellLevelsSites";

export function WellLevelsForm({ formik }: { formik: FormikProps<WellLevelViewFormValues> }) {
  const { startDate, endDate } = formik.values;
  return (
    <VStack alignItems={"stretch"}>
      <HStack direction="row" alignItems={"stretch"}>
        <Box flex="1">
          <Input
            id="startDate"
            placeholder="Start Date"
            size="md"
            type="date"
            value={startDate}
            onChange={formik.handleChange}
            onBlur={() => formik.handleSubmit()}
            onKeyUp={handleEnter}
          />
        </Box>

        <Box flex="1">
          <Input
            id="endDate"
            placeholder="End Date"
            size="md"
            type="date"
            value={endDate}
            onChange={formik.handleChange}
            onBlur={() => formik.handleSubmit()}
            onKeyUp={handleEnter}
          />
        </Box>
      </HStack>
      <SelectWellLevelsSites formik={formik} />
    </VStack>
  );
}

function handleEnter(e: React.KeyboardEvent<HTMLInputElement>) {
  if (e.key === "Enter") {
    e.preventDefault();
    e.currentTarget.blur();
  }
}
